import { apiUtils } from "../../../utils/apiUtils";
import type { RuntimeConfiguration } from "../types/runtimeConfiguration.types";

export function getRuntimeConfiguration(signal?: AbortSignal) {
  return apiUtils.getData<RuntimeConfiguration>(
    "/v1/portal/runtime-configuration",
    "Failed to load runtime configuration",
    { signal },
  );
}
